module.exports = __webpack_public_path__ + "img/logo_lg_light.be37e657.png";